import { Module } from 'vuex/types';

type UIState = {
  hideAnsweredQuestions: boolean;
};

export default {
  namespaced: true,

  state: {
    hideAnsweredQuestions: false,
  },

  mutations: {
    ['set:hideAnsweredQuestions'](state, hide: boolean) {
      state.hideAnsweredQuestions = hide;
    },
  },
} as Module<UIState, any>;
